import { getCurrentInstance, ref } from 'vue';
// eslint-disable-next-line import/no-extraneous-dependencies
import debounce from 'lodash/debounce';
import Toast from 'vant/lib/toast';
import { saveAs } from 'file-saver';
import { sendLog } from '~/common/radar';
import { Picture } from '~/api/topic';

type PictureActionItemProps = {
    index?: number;
    picture?: Picture;
    isLoginStatus?: boolean;
};

export const PictureActionItemSeoSetup = (props: PictureActionItemProps) => {
    const { proxy } = getCurrentInstance() || {};
    const isLiked = ref(false);
    const isVideoDownloading = ref(false);

    const sendCardLog = (buttonType: string) => {
        sendLog({
            type: 'click',
            name: 'PHOTO_CARD_SPECIAL',
            value: {
                button_type: buttonType,
                card_type: 'photo_text',
                card_position: props.index,
            },
        });
    };

    const checkLoginStatus = (action: Function) => {
        if (!props.isLoginStatus) {
            (proxy as Record<string, any>)?.$bus?.emit?.('changeLoginPopupShow', true);
            return false;
        }
        action();
        return true;
    };

    const excuteLikeAction = debounce(() => {
        sendCardLog('like');
        checkLoginStatus(() => {
            isLiked.value = !isLiked.value;
        });
    }, 300);

    const excuteCommentAction = debounce(() => {
        sendCardLog('comment');
        checkLoginStatus(() => {
            Toast({
                message: proxy?.$root?.$t('pictuer_click_comment_toast'),
            });
        });
    }, 300);

    const excuteDownloadAction = debounce(async () => {
        sendCardLog('download');
        if (!checkLoginStatus(() => {})) return;

        Toast({
            message: (proxy as Record<string, any>)?.$root?.$t?.('download_started'),
        });

        if (!isVideoDownloading.value) {
            isVideoDownloading.value = true;
            try {
                const pictureUrl = props.picture?.pic_origin_url || '';
                if (!pictureUrl) throw new Error('Picture URL not found');

                const response = await fetch(pictureUrl);
                if (!response.ok) throw new Error('Network response was not ok');

                const blob = await response.blob();
                saveAs(blob, `picture_${props.picture?.pic_id_str}.png`);
            } catch (error) {
                // eslint-disable-next-line no-console
                console.error('Error downloading picture:', error);
            } finally {
                isVideoDownloading.value = false;
            }
        }
    }, 300);

    return {
        isLiked,
        excuteLikeAction,
        excuteCommentAction,
        excuteDownloadAction,
    };
};
